import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SvgModule } from '@shared/components/svg/svg.module';
import { ReactiveFormsModule } from '@angular/forms';
import { NgLetModule } from '@shared/directives/ng-let/ng-let.module';
import { TranslateModule } from '@ngx-translate/core';
import { DeclensionWordModule } from '@shared/pipes/declension-word/declension-word.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SafeHtmlModule } from '@shared/pipes/safe-html/safe-html.module';
import { MultiSelectWithInputComponent } from './components/multi-select-with-input/multi-select-with-input.component';
import { MultipleSelectComponent } from '@shared/components/multiple-select/multiple-select';

@NgModule({
  declarations: [MultiSelectWithInputComponent],
  imports: [
    CommonModule,
    MatAutocompleteModule,
    OverlayModule,
    MatCheckboxModule,
    SvgModule,
    ReactiveFormsModule,
    NgLetModule,
    TranslateModule,
    DeclensionWordModule,
    MatTooltipModule,
    SafeHtmlModule,
    MultipleSelectComponent,
  ],
  exports: [MultiSelectWithInputComponent]
})
export class MultiSelectWithInputModule {}
